import React, { useCallback, useEffect, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import { GetAccessCodeList } from "../../Redux/Actions/adminActions";
import { columnsAccessList } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
const AccessList = () => {
    const dispatch = useDispatch();
    const [tempSearch, setTempSearch] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const fetchDetails = useCallback((page, limit, showLoader = true) => {
        const payload = {
            page,
            limit,
            is_deleted: false,
            search: searchQuery,
        };
        dispatch(GetAccessCodeList(payload)).catch(() => {
            if (showLoader) {
                toast.error("Failed to fetch email list");
            }
        });
    },
        [dispatch, pagination.current, pagination.pageSize, searchQuery]
    );

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [fetchDetails, pagination.current, pagination.pageSize]);

    const { list } = useSelector((state) => state.accessList || {});
    const ListData = list?.data?.data;
    const totalCount = list?.data?.pagination?.total;

    useEffect(() => {
        if (totalCount !== undefined) {
            setPagination((prevData) => ({ ...prevData, total: totalCount }));
        }
    }, [totalCount]);

    const handleTableChange = (pagination) => {
        setPagination(pagination);
        fetchDetails(pagination.current, pagination.pageSize);
    };

    const filterHandler = () => {
        setSearchQuery(tempSearch);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    return (
        <TableComponent
            h3heading="Access List"
            columns={columnsAccessList(pagination.current, pagination.pageSize)}
            onChange={handleTableChange}
            filterFunction={filterHandler}
            onPressEnter={filterHandler}
            setState={setTempSearch}
            pagination={pagination}
            dataSource={Array.isArray(ListData) ? ListData : []}
        ></TableComponent>
    );
};

export default AccessList;
